import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../../components/SeoHead';
import MainBanner from '../../../../components/MainBanner';
import GetInTouch from '../../../../components/GetInTouch';
import MultiColumnCTAWithDivider from '../../../../components/MultiColumnCTAWithDivider';

export default function JoinUsPage({
    global,
    all_branches
}) {
    return (
        <>
            <SeoHead
                page_name={`Join Us | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
                canonical_link={`about-us/join-us`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`join_us_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Join Us</h1>
                        <p>Join our team of global technology recruitment professionals</p>
                    </>
                }
                imageURL1={`/site-assets/images/join-us-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <GetInTouch
                global={global}
                pathPrefix={`join_us_page.get_in_touch`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>There are many way to get in touch.</p>
                    </>
                }
                content_2={
                    <>
                        <h3>
                            Send Us Your CV/Resume
                        </h3>
                    </>
                }
                buttonLink={`/`}
                buttonTitle={`Submit your CV/Resume`}
                post={all_branches}
                successPageUrl={`/us/contact-us/submission-success`}
                popUpModal_1={true}
                popUpModal_1_form_id={`05bfd90b-f572-40f9-a5d2-00de82f93e81`}
                dialog_content_1={
                    <h5>Upload CV/Resume</h5>
                }
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`join_us_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Newsletter Sign up</h2>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/contact-us/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`For Candidates`}
                buttonLink2_1={`/`}
                buttonTitle2_1={`For Clients`}
                popUpModal_1={true}
                popUpModal_2={true}
                popUpModal_1_form_id={`cd1920b5-88e6-44ba-90a2-7f0044affd3f`}
                popUpModal_2_form_id={`4a90fc83-5a51-463e-9747-c31cdde81170`}
                dialog_content_1={
                    <h5>For candidates</h5>
                }
                dialog_content_2={
                    <h5>For clients</h5>
                }
                successPageUrl={`/us/submission-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const branches = await Collection('branches_us');

    const all_branches = branches.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_branches
        }
    };
}
